module.exports = __webpack_public_path__ + "img/dgd.f244fa5b.svg";